import React from "react";
import SearchResults from "./components/SearchResults";
import getFavItems from "../favourites/utils/getFavItems";
import {createRoot} from "react-dom/client";

export default () => {

    const dom = document.querySelector('[data-product-results]');
    if (dom) {
        const searchRoot = createRoot(dom);
        const json = JSON.parse(dom.getAttribute('data-product-results'));
        getFavItems().then((data) => {
            searchRoot.render(
                <SearchResults
                    products={json}
                />
            );
        });
    }

}
